import { BarChart3, Brain, ClipboardList, Cpu, Tag, Wrench } from 'lucide-react';
import { TRACEABILITY, ANALYTICS, ML, TOOL_RECOMMENDER } from '@/constants/modules';
import { ScannerHeroCard } from './ScannerHeroCard';
import { ModuleCard } from './ModuleCard';

interface DashboardGridProps {
  modules: string[];
}

export function DashboardGrid({ modules }: DashboardGridProps) {
  const hasTraceability = modules.includes(TRACEABILITY);
  const hasAnalytics = modules.includes(ANALYTICS);
  const hasML = modules.includes(ML);
  const hasToolRecommender = modules.includes(TOOL_RECOMMENDER);

  return (
    <div
      className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 md:grid-cols-3"
      data-testid="dashboard-grid"
    >
      {hasTraceability && (
        <div className="sm:col-span-2 md:col-span-2">
          <ScannerHeroCard />
        </div>
      )}

      {hasAnalytics && (
        <ModuleCard
          titleKey="home.dashboard.analyticsTitle"
          descriptionKey="home.dashboard.analyticsDescription"
          icon={<BarChart3 className="h-6 w-6" />}
          href="/analytics"
          accent="analytics"
        />
      )}

      {hasML && (
        <ModuleCard
          titleKey="home.dashboard.mlTitle"
          descriptionKey="home.dashboard.mlDescription"
          icon={<Brain className="h-6 w-6" />}
          href="/ml"
          accent="ml"
        />
      )}

      {hasTraceability && (
        <ModuleCard
          titleKey="home.dashboard.toolViewTitle"
          descriptionKey="home.dashboard.toolViewDescription"
          icon={<Wrench className="h-6 w-6" />}
          href="/traceability/tools"
          accent="tools"
        />
      )}

      {hasTraceability && (
        <ModuleCard
          titleKey="home.dashboard.workshopTitle"
          descriptionKey="home.dashboard.workshopDescription"
          icon={<ClipboardList className="h-6 w-6" />}
          href="/traceability/workshop"
          accent="traceability"
        />
      )}

      <ModuleCard
        titleKey="home.dashboard.labelizeTitle"
        descriptionKey="home.dashboard.labelizeDescription"
        icon={<Tag className="h-6 w-6" />}
        href="/labelize"
        accent="labelize"
      />

      {hasToolRecommender && (
        <ModuleCard
          titleKey="home.dashboard.toolRecommenderTitle"
          descriptionKey="home.dashboard.toolRecommenderDescription"
          icon={<Cpu className="h-6 w-6" />}
          href="/tool-recommender"
          accent="recommender"
        />
      )}
    </div>
  );
}
